export const getForumAction = (actionType: number): string => {
  return ''
}
